<div class="text-center">
  <p class="text text-danger"
    i18n="@@checkout_sdk.error.form_options_not_loaded">
    checkout_sdk.error.form_options_not_loaded
  </p>
  <button type="button" class="btn btn-primary btn-sm" (click)="doTryAgain($event)"
    i18n="@@checkout_sdk.action.try_again">
    checkout_sdk.action.try_again
  </button>
</div>
